import Space, {SizeValues} from './Space';

export type {SizeValues};
export default Space;
